import React from 'react';
import Table, { TableActions } from 'components/Table';
import commonColumns from './commonColumns';
import { numberToCurrencyString, dateToLabel } from 'further-ui/utils';
import { AttachFile } from '@mui/icons-material';
import DeleteAction from 'components/Actions/Delete';
import type { QueuedWithdrawal } from 'hooks/data/withdrawal/types';

type Props = {
  queuedWithdrawals: Array<QueuedWithdrawal>;
  removeWithdrawalFromQueue: (queueId: string) => void;
};

const QueuedWithdrawalsTable: React.FC<Props> = ({
  queuedWithdrawals,
  removeWithdrawalFromQueue,
}) => {
  const columns = [
    ...commonColumns(),
    {
      label: 'Net withdrawal amount',
      key: 'netWithdrawalAmount',
      sort: false,
      render: (elm) =>
        numberToCurrencyString(elm?.withdrawalDetails?.netWithdrawalAmount),
    },
    {
      label: 'Withdrawal fee',
      key: 'withdrawalFee',
      sort: false,
      render: (elm) =>
        numberToCurrencyString(elm?.withdrawalDetails?.withdrawalFee),
    },
    {
      label: 'Total withdrawal',
      key: 'totalWithdrawal',
      sort: false,
      render: (elm) =>
        numberToCurrencyString(elm?.withdrawalDetails?.totalWithdrawal),
    },
    {
      label: 'Withdrawal date',
      key: 'withdrawalDate',
      sort: false,
      render: (elm) =>
        elm?.withdrawalDetails?.withdrawalDate
          ? dateToLabel(elm.withdrawalDetails.withdrawalDate)
          : '-',
    },
    {
      label: 'Notes',
      key: 'note',
      sort: false,
      render: (elm) => elm?.withdrawalDetails?.note || '-',
    },

    {
      label: '',
      key: 'actions',
      sort: false,
      render: (elm) => (
        <TableActions
          showAsDropdown
          actions={[
            {
              visible: !!elm?.withdrawalDetails?.attachment?.signedGetUrl,
              icon: AttachFile,
              link: elm?.withdrawalDetails?.attachment?.signedGetUrl,
              label: 'View attachment',
              external: true,
            },
            {
              actionComponent: DeleteAction,
              onClick: () => removeWithdrawalFromQueue(elm.queueId),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      tablebody={queuedWithdrawals}
      variant="nohover"
      getRowId={(row) => row.queueId}
    />
  );
};

export default QueuedWithdrawalsTable;
